import React from 'react';
import {Box} from "@mui/material";
import Typography from "@mui/material/Typography";

type Props = {
    id: number
    weekDay: number,
    dayNum: number,
    month: string

}
export const weekDaysName = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']

const DaysList: React.FC<Props> = ({weekDay, dayNum, id, month}) => {
    const convertWeekDay = (weekDayNum: number) => {
        return weekDaysName[weekDayNum]
    }
    return (
        <Box sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            borderRight: "1px solid #c9c7c7",
            // borderLeft: "1px solid #c9c7c7",
            height: "100%",
            minWidth: "52px",
            // width:"100%"
        }}>
            {
                <>
                    <Typography sx={{
                        color: "primary.dark",
                        borderBottom: "1px solid #c9c7c7",
                        borderRadius: "1px",
                        width: "100%",
                        p: "2px",
                        overflow: "hidden",
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "center"
                    }}>
                        {month}
                    </Typography>
                    <Typography sx={{
                        color: "primary.dark"
                    }}>
                        {convertWeekDay(weekDay)}
                    </Typography>
                    <Typography sx={{
                        color: "primary.light"
                    }}>{dayNum}</Typography>
                </>

            }
        </Box>
    );
};

export default DaysList;